import React, { useState } from 'react';
import { Box, Button, Checkbox, FormControlLabel } from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';

import { PaymentForm } from '@shared/components/PaymentForm';
import ConditionsDialog from './Conditions';
import { sxStyle } from './styles';

const CreditCardForm = ({ payWithCard }) => {
  const [openModal, setOpenModal] = useState(false);
  const [aceptCheckout, setAceptCheckout] = useState(false);
  const [cardValues, setCardValues] = useState(null);

  // Se guarda la info de la tarjeta cuando el PaymentForm llama a esta función
  const handleSubmitPayment = values => {
    setCardValues(values);
    setOpenModal(true); // Mostramos modal de condiciones
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  // Solo marca la aceptación y cierra el modal
  const aceptCondition = () => {
    setAceptCheckout(true);
    setOpenModal(false);
  };

  // Función que se dispara al hacer click en Pagar
  const handlePayClick = () => {
    if (cardValues && aceptCheckout) {
      const mappedCardData = {
        card_holder_name: cardValues.name,
        card_number: cardValues.number,
        card_code_value: cardValues.cvc,
        card_holder_identification_number: cardValues.dni,
        card_exp_month: cardValues.card_exp_month,
        card_exp_year: cardValues.card_exp_year.padStart(2, '0'), // asegurar 2 dígitos
        card_holder_identification_type: 'dni',
      };
      payWithCard(mappedCardData);
    }
  };

  return (
    <>
      {/* 🟦 FORMULARIO DE TARJETA */}
      <PaymentForm paymentValues={handleSubmitPayment} />

      {/* 🟦 ACEPTACIÓN DE CONDICIONES + BOTÓN DE PAGO */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          mt: 2,
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <FormControlLabel
            style={{ margin: 0 }}
            control={
              <Checkbox
                checked={aceptCheckout}
                onChange={() => setAceptCheckout(!aceptCheckout)}
                checkedIcon={
                  <DoneIcon style={{ color: 'rgb(170, 230, 230)' }} />
                }
              />
            }
          />
          <span style={{ marginRight: 4 }}>Leí y acepto las</span>
          <Button onClick={() => setOpenModal(true)}>
            condiciones de compra
          </Button>
        </div>

        <Button
          disabled={!aceptCheckout || !cardValues}
          sx={sxStyle.btn}
          onClick={handlePayClick}
        >
          Pagar
        </Button>
      </Box>

      {/* 🟦 MODAL DE TÉRMINOS */}
      <ConditionsDialog
        openModal={openModal}
        handleCloseModal={handleCloseModal}
        aceptCondition={aceptCondition}
      />
    </>
  );
};

export default CreditCardForm;
